import React from 'react';
import { Helmet } from 'react-helmet';

export default function LayoutBasic(props) {
  const { children } = props;

  return <div>{children}</div>;
}
